import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-zinc-200 border-t-[#0654BA] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!user.is_admin) {
    return (
      <div className="section-pad py-20 text-center" data-testid="admin-forbidden">
        <h1 className="font-display font-bold text-3xl">403 — Admin only</h1>
        <p className="text-zinc-500 mt-2">You don&apos;t have access to this area.</p>
      </div>
    );
  }
  return children;
}
